<script setup lang="ts">
  import type { PropType } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  interface Item {
    header: string,
    content: string,
  }

  defineProps({
    header: { type: String },
    headerType: { type: String },
    content: { type: String },
    items: { type: Array as PropType<Item[]>, default: [], required: false },
  });
</script>
<template>
  <SfSection v-if="items.length > 0" :title="header" :headerType class="faq-block">
    <QuillContent v-if="content" :content />
    <Collapsible v-for="item in items" enable>
      <template #header>
        {{ item.header }}
      </template>
      <template #content>
        <div v-if="item.content" class="faq-block__collapsible-content">
          <QuillContent :content="item.content" />
        </div>
      </template>
    </Collapsible>
  </SfSection>
</template>
<style lang="scss">
  :root {
    --faq-block-section-gap: 1rem;
    --faq-block-content-gap: 0rem;
    --faq-block-quill-content-font-size: 0.875rem;
    --faq-block-collapsible-content-padding-inner: 0 0 1rem;
  }
</style>
<style lang="scss" scoped>
  .faq-block {
    --section-content-gap: var(--faq-block-content-gap);
    --section-gap: var(--faq-block-section-gap);
    --sf-quill-content-font-size: var(--faq-block-quill-content-font-size);
    --sf-collapsible-content-padding-inner: var(--faq-block-collapsible-content-padding-inner);

    :deep(.collapsible__header-container) {
      @media (hover: hover) {
        &:hover {
          text-decoration: underline;
        }
      }
    }

    @media(max-width: 992px) {
      :deep(.section__content) {
        padding: 0 0.625rem;
      }
    }
  }
</style>
